import * as THREE from 'three';
import vBasicHatchingShader from '../shaders/basic_hatching_vert.glsl'
import fBasicHatchingShader from '../shaders/basic_hatching_frag.glsl'
import { DoubleSide, FrontSide } from 'three';


export class BasicHatchingMaterial extends THREE.ShaderMaterial {
  constructor(parameters) {

  const hatchingMap = parameters.hatchingMap || null
  const map = parameters.map || null
  const hatchingScale = parameters.hatchingScale || 10
  const mixDiffuse = parameters.mixDiffuse || 0
  const gamma = parameters.gamma || 2.2
  const blackLevel = parameters.blackLevel || 0
  const whiteLevel = parameters.whiteLevel || 1

  const uniforms = {
      map : {value : map},
      hatchingScale: { value: hatchingScale },
      hatchingMap: { value: hatchingMap },
      mixDiffuse: { value: mixDiffuse },
      gamma: { value: gamma },
      blackLevel: { value: blackLevel },
      whiteLevel: { value: whiteLevel },
  }
  let vertexShader = vBasicHatchingShader
  let fragmentShader = fBasicHatchingShader

    super({
      vertexShader: vertexShader,
      fragmentShader: fragmentShader,
      uniforms: uniforms,
      transparent : parameters.transparent || false,
    });
  }
}